export const CompanyDetails = {
  en: {
    'General information': 'General information',
    'Enter company': 'Enter company',
    'API Key': 'API Key',
    Features: 'Features',
    'System Owner log': 'System Owner log',

    'Online Sales': 'Online Sales',
    'Head Office': 'Head Office',
    online_sales: 'Online Sales',
    head_office: 'Head Office',
    online_sales_description:
      'Enable online sales and a virtual Online location for accounting attribution.',
    head_office_description:
      'Enable centralised overhead expenses and a virtual Head Office location.',

    Enabled: 'Enabled',
    Disabled: 'Disabled',
    Enable: 'Enable',
    Disable: 'Disable',
    'Enabled by': 'Enabled by',
    'Enabled on': 'Enabled on',
    'Last reason': 'Last reason',

    'Toggle feature': 'Toggle feature',
    'Current status': 'Current status',
    'New status': 'New status',
    Reason: 'Reason',
    'Reason placeholder': 'Describe why you are changing this feature',
    Status: 'Status',
    'Feature updated': 'Feature updated',

    online_sales_hint:
      'Enables online sales for the company (the sales mechanics live in a separate story). Creates a virtual Online location for accounting attribution. On disable: the Online location is archived, history remains. Can be re-enabled later — the same location is reactivated.',
    head_office_hint:
      'Enables centralised overhead expenses (admin office, central marketing, executive salaries). Creates a virtual Head Office location and one General cash register. On disable: the Head Office location is archived (no longer in P&L breakdowns) BUT its cash registers remain active for cash flow and ops continuity.',

    head_office_non_zero_balance:
      'The Head Office still has cash registers with a non-zero balance. The location has been archived, but its cash registers remain active.',

    'System Owner': 'System Owner',
    Action: 'Action',
    Feature: 'Feature',
    feature_toggle: 'Feature toggle',
    'No log entries': 'No log entries',
  },
  uk: {
    'General information': 'Загальна інформація',
    'Enter company': 'Увійти в компанію',
    'API Key': 'API ключ',
    Features: 'Функції',
    'System Owner log': 'Журнал системного власника',

    'Online Sales': 'Онлайн-продажі',
    'Head Office': 'Головний офіс',
    online_sales: 'Онлайн-продажі',
    head_office: 'Головний офіс',
    online_sales_description:
      'Увімкнути онлайн-продажі та віртуальну онлайн-локацію для бухгалтерської атрибуції.',
    head_office_description:
      'Увімкнути централізований облік витрат і віртуальну локацію головного офісу.',

    Enabled: 'Увімкнено',
    Disabled: 'Вимкнено',
    Enable: 'Увімкнути',
    Disable: 'Вимкнути',
    'Enabled by': 'Увімкнув(ла)',
    'Enabled on': 'Дата ввімкнення',
    'Last reason': 'Остання причина',

    'Toggle feature': 'Змінити функцію',
    'Current status': 'Поточний статус',
    'New status': 'Новий статус',
    Reason: 'Причина',
    'Reason placeholder': 'Опишіть, чому ви змінюєте цю функцію',
    Status: 'Статус',
    'Feature updated': 'Функцію оновлено',

    online_sales_hint:
      'Вмикає для компанії можливість онлайн-продажів (механіка — в окремій історії). Створює віртуальну онлайн-локацію для бухгалтерської атрибуції. При вимиканні: онлайн-локація архівується, історія лишається. Можна повторно увімкнути — та сама локація активується знову.',
    head_office_hint:
      'Вмикає централізований облік витрат (адмін-офіс, центральний маркетинг, керівні зарплати). Створює віртуальну локацію головного офісу й одну загальну касу. При вимиканні: локація головного офісу архівується (не показується в P&L), АЛЕ каси головного офісу лишаються активними.',

    head_office_non_zero_balance:
      'Головний офіс усе ще має каси з ненульовим балансом. Локацію заархівовано, але її каси лишаються активними.',

    'System Owner': 'Системний власник',
    Action: 'Дія',
    Feature: 'Функція',
    feature_toggle: 'Перемикання функції',
    'No log entries': 'Немає записів',
  },
};
